export default __webpack_public_path__ + "static/media/tiktok.201161b2.svg";